module.exports = __webpack_public_path__ + "img/zw-bg.224068a1.png";